import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Price } from '@/types';
import { useQuery } from '@tanstack/react-query';

type PriceListParams = {
  promotion?: string | null;
  campaignCode?: string | null;
  isoCountryCode?: string;
};

const normalizePriceListParams = ({
  promotion,
  campaignCode,
  isoCountryCode,
}: PriceListParams) => {
  // TODO: promotion は将来的に廃止予定。campaignCode のみで扱う形に整理する。
  const normalizedCampaignCode = campaignCode ?? null;
  const normalizedPromotion = normalizedCampaignCode
    ? null
    : (promotion ?? null);

  return {
    promotion: normalizedPromotion,
    campaignCode: normalizedCampaignCode,
    isoCountryCode,
  };
};

export const getPriceList = ({
  promotion,
  campaignCode,
  isoCountryCode,
}: PriceListParams): Promise<Price[]> => {
  const normalizedParams = normalizePriceListParams({
    promotion,
    campaignCode,
    isoCountryCode,
  });

  return axios.get('/api/v1/payments/price_lists', {
    params: {
      promotion: normalizedParams.promotion ?? undefined,
      campaignCode: normalizedParams.campaignCode ?? undefined,
      isoCountryCode: normalizedParams.isoCountryCode,
    },
  });
};

type QueryFnType = typeof getPriceList;

type UsePriceListsOptions = PriceListParams & {
  config?: QueryConfig<QueryFnType>;
};

export const usePriceLists = ({
  promotion,
  campaignCode,
  isoCountryCode,
  config = {},
}: UsePriceListsOptions) => {
  const normalizedParams = normalizePriceListParams({
    promotion,
    campaignCode,
    isoCountryCode,
  });

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['payments/price_lists', normalizedParams],
    queryFn: () => getPriceList(normalizedParams),
  });
};
